export default __webpack_public_path__ + "static/media/waulfy.a3a63ac3.png";